import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SignInService } from '../../../../common/services/sign-in/sign-in.service';
import { LockByUserDTO } from '../../../../common/event-dtos';
import { BlastV2Service } from './blast-v2.service';

@Injectable({
  providedIn: 'root',
})
export class LockService {
  constructor(
    private blastV2Service: BlastV2Service,
    private signInService: SignInService
  ) {}

  public isEntryLocked(entry: any) {
    return entry.locked && entry.locked.email && entry.locked.email.length > 0;
  }

  public isEntryLockedByCurrentAdmin(entry: any) {
    return entry?.locked?.email === this.signInService.getCurrentUser().email;
  }

  public lockTicker(collection: string, tickerId: number) {
    this.blastV2Service.sendMessage({
      collection,
      cmd: 'lock',
      data: {
        email: this.signInService.getCurrentUser().email,
        image: this.signInService.getCurrentUser().imageUrl,
      } as LockByUserDTO,
      tickerId,
    });
  }
}
